import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { AuthService, UserModel } from 'src/app/modules/auth';
import { GroupingState, PaginatorState, SortState } from 'src/app/_metronic/shared/crud-table';
import { HelperServices } from '../_services/helper.services';
import { InsuranceService } from '../_services/insurance.services';

enum SubmitStates {
    NotSubmitted,
	HasEmpty,
    HasError,
    NoError,
    CodeError,
    HasSuccess
}

@Component({
	selector: 'app-send-policy-documents',
	templateUrl: './send-policy-documents.component.html',
	styleUrls: ['./send-policy-documents.component.scss']
})

export class SendPolicyDocumentsComponent implements
	OnInit, 
	OnDestroy {
	loadingModalConfig: NgbModalOptions = {
		backdrop : 'static',
		keyboard : false
	};
	submitState: SubmitStates = SubmitStates.NotSubmitted;
    submitStates = SubmitStates;
	loadingModal: boolean = false;
	paginator: PaginatorState;
	sorting: SortState;
	grouping: GroupingState;
	isLoading: boolean;
	templateView: number = 1;
	user$: Observable<UserModel>;
	_user: UserModel;
	hasError: boolean;
	ramos: any;
	subramos: any;
	anyos: any;
	meses: any;
	endosos: any;
	companies: any;
	tiposEndosos;
	insuredFilter: number = 0;
	showComapnyName: boolean = false;
	activeSubmitFilterPolicy: boolean = false;
	filterPolicyForm: FormGroup;
	sendDocumentForm: FormGroup;
	IdRamo: boolean = false;
	templatePostEndoso: number = 1;
	tipoFiltroInteres: any;
	resultPostEndosoMessage: string;
	detalleInteresAsegurado: any;
	private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
	permissionMenu: any;
	config: any;
	policies: any = [];

	constructor(
		public insuranceService: InsuranceService,
		private auth: AuthService,
		private fb: FormBuilder,
		private modalSendDocument: NgbModal,
		private modalLoading: NgbModal,
		public sanitizer: DomSanitizer,
		public helperServices: HelperServices
	) {}

	// angular lifecircle hooks
	async ngOnInit() {
		this.initForm();

		this.user$ = this.auth.currentUserSubject.asObservable();
		this.user$.subscribe(user=> {
		this._user = user;
		});

		this.insuranceService.fetch();
		this.paginator = this.insuranceService.paginator;

		this.ramos = this.insuranceService.getRamos();
		this.meses = this.insuranceService.getMeses();
		this.anyos = this.insuranceService.getAnyos();
		this.companies = this.helperServices.getCompaniaSeguros();
		this.tipoFiltroInteres = this.helperServices.getTipoFiltroInteres();
		//this.tiposEndosos = this.insuranceService.getAnyos();
		this.permissionMenu = JSON.parse(localStorage.getItem("permissionMenu"))[0];
		this.config = JSON.parse(localStorage.getItem("remote_params"));
		const sb1 = this.insuranceService.isLoading$.subscribe(res => this.isLoading = res);
		this.subscriptions.push(sb1);
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sb) => sb.unsubscribe());
	}

	initForm() {
		this.filterPolicyForm = this.fb.group({
			inputMes: [''],
			inputAnyo: [''],
			inputRamo: [''],
			inputSubRamo: [''],
			inputNroDePoliza: [''],
			inputAsegurado: [''],
			inputPlaca: [''],
			inputIdentificacion: [''],
			inputIdCompania: [''],
			inputGrupoEconomico: ['']
		  });
	  
		  this.sendDocumentForm = this.fb.group({
			inputEmail: [''],
		  });
	}

	changeFilterMode(event) {
		this.insuredFilter = event.target.value;
	  }
	
	changeRamo(event) {
		this.subramos = this.insuranceService.getSubRamos("IdRamo=" + event.target.value).finally(() => {
			this.IdRamo = event.target.value > 0 ? event.target.value : false;
		});
	}

	submitFilterPolicy(content) {
		var paramsGet = Array( 
			`IdEntidad=${this._user.id}`,
			`Asegurado=${this.filterPolicyForm.value.inputAsegurado || ''}`,
			`IdRamo=${this.filterPolicyForm.value.inputRamo || ''}`,
			`IdSubRamo=${this.filterPolicyForm.value.inputSubRamo || ''}`,
			`IdMes=${this.filterPolicyForm.value.inputMes || ''}`,
			`IdAno=${this.filterPolicyForm.value.inputAnyo || ''}`,
			`NroDePoliza=${this.filterPolicyForm.value.inputNroDePoliza || ''}`,
			`Identificacion=${this.filterPolicyForm.value.inputIdentificacion || ''}`,
			`Placa=${this.filterPolicyForm.value.inputPlaca || ''}`
		)

		if(this.permissionMenu.VerGrupoEconomico == 1) {
			paramsGet.push(`GrupoEconomico=${this.filterPolicyForm.value.inputGrupoEconomico || ''}`);
		}

		if(this.permissionMenu.VerCompania == 1) {
			paramsGet.push(`IdCompania=${this.filterPolicyForm.value.inputIdCompania || ''}`);
		}

		this.insuranceService.patchState({ paramsGet : paramsGet.join('&') });
	}


	processPolicies(content) {
		this.policies = [];
		this.submitState = SubmitStates.NotSubmitted;
		this.sendDocumentForm.patchValue({ inputEmail : "" });

		for(let i = 0; i < this.insuranceService.paginator.total; i++ ) {
			if( (<HTMLInputElement> document.getElementById("idPolicy"+i)).checked) {
				this.policies.push({
					"IdPoliza" : (<HTMLInputElement> document.getElementById("idPolicy"+i)).value, 
					"Email" : (<HTMLInputElement> document.getElementById("idPolicy"+i)).getAttribute("data-email")
				});
			}
		}

		if(this.policies.length) {
			this.modalLoading.open(content, this.loadingModalConfig);
		}
		else {
			this.submitState = SubmitStates.HasEmpty;
		}
	}

	submitSendDocument(content) {
		var g = this;
		g.submitState = SubmitStates.NotSubmitted;

		if(this.sendDocumentForm.valid) {
			this.modalLoading.open(content, this.loadingModalConfig);
			// "Email":this.sendDocumentForm.value.inputEmail
			this.helperServices.postEnviarDocumentosPolizas(Array({"Poliza":this.policies})).then(response => {
				if(typeof(response[0].Success) != "undefined") {
					this.modalLoading.dismissAll();

					if(response[0].Success) {
						g.submitState = SubmitStates.HasSuccess;

						alert(response[0].Mensaje);
					}
					else {
						g.submitState = SubmitStates.CodeError;
					}
				}
			}).finally(()=>{
			});
		}
		else {
			g.submitState = SubmitStates.HasError;
		}
	}

}
